import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';



import Home from './pages/homepage.jsx';
import Footer from './components/Footer'
import PacketGenerator from './pages/packetGenerator';
import WorkInProgress from './pages/Workinprogress';
import Leaderboard from './pages/LeaderboardPage.jsx';
import AboutUs from './pages/Aboutus.jsx';
import Parser from "./pages/parser.jsx"
import PacketView from './pages/PacketView.jsx';
import NotFoundPage from './pages/404Page.jsx'; // Adjust path as needed
import AdminPanel from './components/AdminPanel';


function App() {
  return (

            <Router>
              <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
{/*                 
                    <WorkInProgress 
                      title="Coming Soon" 
                      message="Our team is working hard to deliver this feature by next month." 
                      theme="dark"
                      type="overlay"
                    /> */}
                <div style={{ flex: 1, padding: '0' }}>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/packetGen" element={<PacketGenerator />} />
                    <Route path="/leaderboard" element={<Leaderboard />} />
                    <Route path="/about" element={<AboutUs />} />
                    <Route path="/parser" element={<Parser />} />
                    <Route path="/packet/:packetId/question/:questionIndex" element={<PacketView />} />
                    <Route path="/packet/:packetId" element={<PacketView />} /> 
                    <Route path="/admin" element={<AdminPanel />} />

                    <Route path="*" element={<NotFoundPage />} />
                  </Routes>
                </div>

                <Footer /> 
              </div>
            </Router>
  );
}

export default App;
